import { Card, CardBody, Tab, Tabs } from "@nextui-org/react";
import AddPaint from "./AddPaint";
import EditForm from "./EditPaint";
import RemovePaint from "./RemovePaint";
import BackUp from "./BackUp";
import { useNavigate, useSearchParams } from "react-router-dom";
import PaintList from "./PaintList";

const Painting = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const tab = searchParams.get('tab');

    const changeTab = (value) => {
        const newParams = new URLSearchParams();
        newParams.set('tab', value);
        navigate({ search: `?${newParams.toString()}` }, { replace: true });
    }

    return (
        <>
            <div className="w-full flex flex-col">
                <Tabs
                    aria-label="Options"
                    className="border-b pb-3"
                    selectedKey={tab || 'list'}
                    onSelectionChange={changeTab}
                >
                    <Tab key="list" title="لیست">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <PaintList />
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="new" title="جدید">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <AddPaint />
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="edit" title="ویرایش">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <EditForm edit={true} />
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="delete" title="حذف">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <RemovePaint />
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="export" title="بک آپ">
                        <Card style={{ boxShadow: 'none' }}>
                            <CardBody>
                                <BackUp />
                            </CardBody>
                        </Card>
                    </Tab>
                </Tabs>
            </div>
        </>
    );
};

export default Painting;